module.exports = __webpack_public_path__ + "static/carousel-slide-03-e6b8d657d060ff1d673a0f02f15f8ac7.png";